import {gsap} from "gsap";

export default function animations() {
    // Select all elements with the "fade-up" class and apply the animation
    if (window.matchMedia("(min-width: 991px)").matches) {
        gsap.utils.toArray('.fade-up-element').forEach(element => {
            gsap.to(element, {
                opacity: 1,
                y: 0,
                duration: 0.5,
                //ease: 'power1.out',
                scrollTrigger: {
                    trigger: element,
                    start: 'top 90%',  // Starts when element enters viewport
                    toggleActions: 'play none none none',  // Only plays the animation once
                }
            });
        });
    }
}
